import { render, staticRenderFns } from "./teacher-academic-data.vue?vue&type=template&id=05a25b8e&"
import script from "./teacher-academic-data.vue?vue&type=script&lang=js&"
export * from "./teacher-academic-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports